import React from 'react'
import formatCost from '../../../../utils/formatCost'
import { UpgradeCost } from '@prometheus/types'
import { Card, Popup, Typography } from '@prometheus/components'

export const MineCostPopup = ({ children, cost }: { children: any, cost: UpgradeCost }) => {
  return (
    <Popup position="right center" trigger={children}>
      <Card padding="sm">
        <Typography style={{ lineHeight: 1 }} retro color="danger">-{formatCost(cost)}</Typography>
      </Card>
    </Popup>
  )
}
